export function isReadOnlyTeacherDemo(user) {
  const roles = Array.isArray(user?.roles) ? user.roles : [user?.role];
  return Boolean(user?.read_only_demo || (user?.is_demo && roles.includes('teacher')));
}

export function canEnterDataPoints(user) {
  const roles = [user?.role, ...(Array.isArray(user?.roles) ? user.roles : [])];
  const teacherDemo = (user?.is_demo || user?.read_only_demo)
    && roles.some(role => role === 'teacher' || role === 'special_services_teacher');
  return !isReadOnlyTeacherDemo(user) || Boolean(teacherDemo);
}
